import PropTypes from 'prop-types';
import OwnerFields from '../../Detail/GeneralInfo/OwnerFields';
import ScientificSecretaryFields from '../../Detail/GeneralInfo/ScientificSecretaryFields';
import MainParticipantFields from '../../Detail/GeneralInfo/MainParticipantFields';
import ParticipantFields from '../../Detail/GeneralInfo/ParticipantFields';
import DomesticExpertFields from '../../Detail/GeneralInfo/DomesticExpertFields';
import InternationalExpertFields from '../../Detail/GeneralInfo/InternationalExpertFields';
import TechnicianFields from '../../Detail/GeneralInfo/TechnicianFields';

export default function ViewHistoricalPersonnelAdjustmentItem({
  members,
  isLoading,
  formatIndex,
  formatFullname,
  formatGender,
  formatResearcherOrganization,
}) {
  return (
    <>
      <OwnerFields
        owners={members
          ?.sort((a, b) => a.order - b.order)
          ?.filter((item) => item?.projectRole?.code?.toLowerCase().includes('owner'))}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatResearcherOrganization={formatResearcherOrganization}
      />
      <ScientificSecretaryFields
        scientificSecretaries={members
          ?.sort((a, b) => a.order - b.order)
          .filter((item) => item?.projectRole?.code?.toLowerCase().includes('secretary'))}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatResearcherOrganization={formatResearcherOrganization}
      />
      <MainParticipantFields
        mainParticipants={members
          ?.sort((a, b) => a.order - b.order)
          ?.filter((item) => item?.projectRole?.code?.toLowerCase().includes('main'))}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatResearcherOrganization={formatResearcherOrganization}
      />
      <ParticipantFields
        participants={members
          ?.sort((a, b) => a.order - b.order)
          .filter((item) => item?.projectRole?.code?.toLowerCase() === 'participant')}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatResearcherOrganization={formatResearcherOrganization}
      />
      <TechnicianFields
        technicians={members
          ?.sort((a, b) => a.order - b.order)
          ?.filter(
            (item) =>
              item?.projectRole?.code?.toLowerCase().includes('technician') ||
              item?.projectRole?.code?.toLowerCase().includes('support')
          )}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatResearcherOrganization={formatResearcherOrganization}
      />
      <DomesticExpertFields
        experts={members
          ?.sort((a, b) => a.order - b.order)
          ?.filter((item) => item?.projectRole?.code?.toLowerCase().includes('domestic'))}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatResearcherOrganization={formatResearcherOrganization}
      />
      <InternationalExpertFields
        experts={members
          ?.sort((a, b) => a.order - b.order)
          .filter((item) => item?.projectRole?.code?.toLowerCase().includes('international'))}
        isLoading={isLoading}
        formatIndex={formatIndex}
        formatFullname={formatFullname}
        formatGender={formatGender}
        formatResearcherOrganization={formatResearcherOrganization}
      />
    </>
  );
}

ViewHistoricalPersonnelAdjustmentItem.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  members: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  formatIndex: PropTypes.func.isRequired,
  formatFullname: PropTypes.func.isRequired,
  formatGender: PropTypes.func.isRequired,
  formatResearcherOrganization: PropTypes.func.isRequired,
};
